import userService from "../../../services/user.service";

async function getCities({ pageNumber, pageSize, searchQuery, countryId = 1 }) {
  try {
    const payload = {
      filter: {
        textSearch: searchQuery,
        countryId,
      },
      pageNumber,
      pageSize,
    };
    const response = await userService.getCities(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return JSON.stringify(response.data.message) || "Failed to fetch cities.";
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error fetching cities:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

async function addCityToDatabase({ cityName, shortName, countryId }) {
  try {
    const payload = {
      name: cityName,
      shortName,
      countryId,
    };
    const response = await userService.addCity(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return JSON.stringify(response.data.message) || "Failed to add city.";
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error adding city:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

async function updateCityInDatabase({
  cityId,
  cityName,
  shortName,
  countryId,
}) {
  try {
    const payload = {
      id: cityId,
      name: cityName,
      shortName,
      countryId,
    };
    const response = await userService.updateCity(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return JSON.stringify(response.data.message) || "Failed to update city.";
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error updating city:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

export default {
  addCityToDatabase,
  getCities,
  updateCityInDatabase,
  cityTools: [
    {
      type: "function",
      function: {
        name: "getCities",
        description:
          "Fetch all cities from the database with pagination and search query.",
        parameters: {
          type: "object",
          properties: {
            pageNumber: {
              type: "number",
              description:
                "The page number for paginated results. Dont ask this just use default values. by default it is -1 for fetching all cities",
            },
            pageSize: {
              type: "number",
              description:
                "The number of items per page. by default it is 0 for fetching all cities",
            },
            searchQuery: {
              type: "string",
              description:
                "Search query to filter cities. by default it is empty string for fetching all cities",
            },
            countryId: {
              type: "string",
              description:
                "The Country id for which you want to get cities. You can call tool to get All countries to display to select.",
            },
          },
          required: ["countryId"],
        },
      },
    },
    {
      type: "function",
      function: {
        name: "updateCityInDatabase",
        description: "Update an existing city in the database.",
        parameters: {
          type: "object",
          properties: {
            cityId: {
              type: "string",
              description: "The unique ID of the city to be updated.",
            },
            cityName: {
              type: "string",
              description: "Name of the city.",
            },
            shortName: {
              type: "string",
              description: "Short name or abbreviation for the city.",
            },
            countryId: {
              type: "number",
              description: "The ID of the country the city belongs to. You can call tool to get All countries to display to select.",
            },
          },
          required: ["cityId", "cityName", "shortName", "countryId"],
        },
      },
    },
    {
      type: "function",
      function: {
        name: "addCityToDatabase",
        description: "Add a new city to the database.",
        parameters: {
          type: "object",
          properties: {
            cityName: {
              type: "string",
              description: "Name of the city.",
            },
            shortName: {
              type: "string",
              description: "Short name or abbreviation for the city.",
            },
            countryId: {
              type: "number",
              description: "The ID of the country the city belongs to.",
            },
          },
          required: ["cityName", "shortName", "countryId"],
        },
      },
    },
  ],
};
